import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface ReportingEmployeesState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "assign" | null;
}

const ReportingEmployeesInitialState: ReportingEmployeesState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getReportingEmployees: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.REPORTING_EMPLOYEES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const findAllEmployeesAttendance: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.FIND_ALL_EMPLOYEES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getMyAttendanceList: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.FIND_EMPLOYEE_REGULARIZE,
        payload
      ); // Replace with correct endpoint
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getMyDailyAttendanceList: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.EMPLOYEES.FIND_DAILY_EMPLOYEE_REGULARIZE,
        payload
      ); // Replace with correct endpoint
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const teamDailyAttendance: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.ATTENDANCE.TEAM_DAILY_ATTENDANCE,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);
export const getTeamShiftHistory: any = createAsyncThunk(
  "get/reporting-employees",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.WORK_SHIFT.EMPLOYEE_SHIFT_HISTORY,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const assignShift: any = createAsyncThunk(
  "assign/shift",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.WORK_SHIFT.ASSIGN_SHIFT,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const reportingEmployeesSlice = createSlice({
  name: "reset",
  initialState: ReportingEmployeesInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getReportingEmployees.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getReportingEmployees.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getReportingEmployees.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });

    builder.addCase(assignShift.pending, (state) => {
      state.data = null;
      state.error = null;
      state.loading = "pending";
      state.action = "assign";
    });
    builder.addCase(assignShift.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = "fulfilled";
      state.action = "assign";
      state.error = null;
    });
    builder.addCase(assignShift.rejected, (state, action) => {
      state.error = action.payload as string;
      state.data = null;
      state.loading = "rejected";
      state.action = "assign";
    });
  },
});

export const { resetAll } = reportingEmployeesSlice.actions;
export default reportingEmployeesSlice.reducer;
